import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BusinessAuthPage.css';

const BASE = (process.env.REACT_APP_API_URL || 'https://halfprice-ca-v2.onrender.com/api').replace(/\/+$/, '');

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch(`${BASE}/auth/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Login failed');

      // Store admin token — same key as business token so Navbar doesn't break
      localStorage.setItem('hp_token', data.token);
      localStorage.setItem('hp_user', JSON.stringify({ ...data.admin, type: 'admin' }));
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="biz-auth-page">
      <div className="biz-auth-left">
        <div className="biz-auth-pitch">
          <div className="biz-auth-logo font-display">half<span>price</span>.ca</div>
          <h2>Admin panel</h2>
          <ul className="pitch-points">
            <li>✓ Manage all restaurants</li>
            <li>✓ Verify new sign-ups</li>
            <li>✓ Change plan levels</li>
            <li>✓ View all leads</li>
            <li>✓ Monitor deals & redemptions</li>
          </ul>
          <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 12, marginTop: 20 }}>
            Izenious Tech Solutions · Internal use only
          </p>
        </div>
      </div>

      <div className="biz-auth-right">
        <div className="auth-form-box fade-up">
          <h1>Admin login</h1>
          <p className="auth-sub">Platform management access. Not for restaurants.</p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Admin email</label>
              <input
                type="email"
                className="form-control"
                placeholder="your admin email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Admin password</label>
              <input
                type="password"
                className="form-control"
                placeholder="your admin password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={loading}
              style={{ justifyContent: 'center', padding: 13 }}
            >
              {loading ? 'Signing in…' : 'Sign in to admin →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
